import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=0305eb35&scoped=true"
import script from "./Terms.ts?vue&type=script&lang=ts&external"
export * from "./Terms.ts?vue&type=script&lang=ts&external"
import style0 from "./Terms.scss?vue&type=style&index=0&id=0305eb35&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0305eb35",
  null
  
)

export default component.exports